import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight, } from "react-icons/md";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { musicianDefaultURL } from "../../../components/CommonApis/CommonArtistApis";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import { ActionFormatterComponent, videoFormatter } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import { toast } from "react-toastify";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { getItemToken } from "../../../Utils/localStorageUtils";

function AllPerformer() {

  const headers = getItemToken('access_token')
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [labelDisplay, setLabelDisplay] = useState([]);

  //Bootstrap Table util start
  const columns = [
    {
      dataField: "artist_name",
      text: "Artist",
      formatter: (cell, row) => videoFormatter(cell, row, musicianDefaultURL?.viewTab),
      sort: true,
      headerClasses: 'video-width-table'
    },
    {
      dataField: "artist_type",
      text: "Artist Type",
      sort: true,
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} link={musicianDefaultURL?.editRouteLink} action={singleDelete} />,
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '30px' },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  //Bootstrap Table util end

  // api start
  const fetchData = async () => {
    try {
      const response = await axios.get(`${musicianDefaultURL?.listApi}`, { headers: headers });
      const result = response?.data?.[musicianDefaultURL?.fetchArrayName];
      setApiData(result);
      setFilteredData(result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "recordholder-artist" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${musicianDefaultURL?.MultiDeleteApi}`, {
        headers: headers,
        data: { [musicianDefaultURL?.reqBodyName?.deleteName]: [...itemToDelete] }
      });
      const result = response?.data;
      if (result?.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setItemToDelete([])
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  // Api links end 
  const closeModal = () => {
    setModelClose(!closeModal);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const handleFilterChange = (data) => {
    setFilteredData(data);
  };


  useEffect(async () => {
    fetchData();
  }, [withOutRefresh]);
  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      <AdminNavbar heading={`Manage ${labelDisplay?.[0]?.title}`} totalDataLength={apiData?.length} deleteCount={itemToDelete?.length} navigation={musicianDefaultURL?.addRouteLink} deleteMethod={openModal} navText={`Add ${labelDisplay?.[0]?.title}`} />
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
        <AdminHeader searchMethod={handleFilterChange} reduceData={filteredData} originalData={apiData} fileName={musicianDefaultURL?.exportFileName} customArtist />
        <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" selectRow={selectRow} selectAll={selectAll} />
      </div>
    </>
  );
}
export default AllPerformer;
